module.exports = __webpack_public_path__ + "img/yangrui.942dec08.jpg";